import React, { Component } from 'react'
import Parser from 'html-react-parser'
import { CloseIcon, PhoneIcon, MapDirectionsIcon, EmailIcon, LocationIcon } from './SVGIcons';

import OffcanvasForm from './OffcanvasForm';

class Offcanvas extends Component {
  static defaultProps = {
    show: false,
    backdrop: true,
    keyboard: true
  };

  state = {
    openMenus: {}, // объект для хранения состояний открытых меню
    showCallForm: false, // состояние для формы заказа звонка
    show_gt: false,
    searchQuery: '', // состояние для поискового запроса
    lightboxOpen: false, // состояние для Lightbox схемы проезда
  };

  componentDidMount() {
    if (this.props.show) {
      this.handleBodyScrollLock(true);
    }
    this.setState({
      show_gt: window.innerWidth < 1200
    });
    // Добавляем обработчик клавиш
    window.addEventListener('keydown', this.handleKeyDown);
  }

  componentDidUpdate(prevProps) {
    if (this.props.show !== prevProps.show) {
      this.handleBodyScrollLock(this.props.show);
      // Сбрасываем открытые меню при закрытии
      if (!this.props.show) {
        this.setState({ openMenus: {}, showCallForm: false, searchQuery: '', lightboxOpen: false });
      }
    }
  }

  componentWillUnmount() {
    if (this.props.show) {
      this.handleBodyScrollLock(false);
    }
    // Удаляем обработчик клавиш и возвращаем прокрутку
    window.removeEventListener('keydown', this.handleKeyDown);
    document.body.style.overflow = 'auto';
  }

  handleBodyScrollLock = (lock) => {
    if (lock) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  };

  handleBackdropClick = (e) => {
    if (e.target === e.currentTarget && this.props.backdrop) {
      this.props.hide();
    }
  };

  handleKeyDown = (e) => {
    if (this.props.keyboard && e.key === 'Escape' && this.props.show) {
      this.props.hide();
    }
    // Обработка Escape для Lightbox
    if (this.state.lightboxOpen && e.key === 'Escape') {
      this.closeSchemaLightbox();
    }
  };

  toggleMenu = (index) => {
    this.setState(prevState => ({
      openMenus: {
        ...prevState.openMenus,
        [index]: !prevState.openMenus[index]
      }
    }));
  };

  // Метод для открытия формы заказа звонка
  openCallForm = () => {
    this.setState({ showCallForm: true });
  };

  // Метод для закрытия формы заказа звонка
  closeCallForm = () => {
    this.setState({ showCallForm: false });
  };

  // Открыть Lightbox со схемой проезда
  openSchemaLightbox = () => {
    this.setState({ lightboxOpen: true });
    document.body.style.overflow = 'hidden';
  }

  // Закрыть Lightbox
  closeSchemaLightbox = () => {
    this.setState({ lightboxOpen: false });
    document.body.style.overflow = '';
  }

  // Обработчик успешной отправки
  handleFormSuccess = (message) => {
    // Закрываем Offcanvas меню
    this.props.hide();
    // Показываем сообщение об успехе
    if (this.props.onSuccess) {
      this.props.onSuccess(message);
    }
  };

  // Обработчик ошибки отправки
  handleFormError = (error) => {
    if (this.props.onError) {
      this.props.onError(error);
    }
  };

  render() {
    const { show, hide, data, backdrop = true } = this.props;
    const { showCallForm, lightboxOpen } = this.state;

    const menu = data?.menu || []
    const catalog_menu = data?.catalog_menu || []
    const links = data?.links || []

    return (
      <>
        {/* Backdrop */}
        {backdrop && (
          <div
            className={`
              fixed inset-0 bg-black/50 backdrop-blur-[4.6px] z-40 
              transition-opacity duration-300 ease-in-out
              ${show ? 'opacity-100' : 'opacity-0 pointer-events-none'}
            `}
            onClick={this.handleBackdropClick}
            onKeyDown={this.handleKeyDown}
            role="presentation"
          />
        )}

        {/* Offcanvas - слева */}
        <div
          className={`
            fixed left-0 top-0 h-full md:max-h-[696px] w-full max-w-[375px] md:max-w-full leading-none
            bg-[#F6F7F8] shadow-xl z-50 
            transition-transform duration-300 ease-in-out
            flex flex-col overflow-hidden
            ${show ? 'translate-x-0 md:translate-y-0' : '-translate-x-full md:translate-x-0 md:-translate-y-full'}
          `}
          role="dialog"
          aria-modal="true"
          onKeyDown={this.handleKeyDown}
        >
          {/* Фиксированная шапка */}
          <div className="shrink-0">
            <div className="container flex items-center justify-between h-[78px] lg:h-[141px]">
              <div className='flex items-center gap-[16px]'>
                <a href="/">
                  <img src={data.logo} width={82} height={40} className='h-auto flex-none' />
                </a>
                <div className='h-[24px] w-px bg-[#1414141A]' />
                <div className='text-small text-ptblack font-light leading-[110%]'>
                  {Parser(data?.slogan || '')}
                </div>
              </div>
              <button
                type="button"
                className="border-0 bg-white h-[38px] lg:h-[42px] px-[11px] lg:px-[22px] rounded-[14px] flex items-center justify-center gap-[12px] text-[14px] text-[#BC0005] hover:bg-gray-200 transition-colors"
                onClick={hide}
                aria-label="Закрыть меню"
              >
                <CloseIcon width={16} height={16} fill="currentColor" />
                <div className='hidden lg:block'>Закрыть меню</div>
              </button>
            </div>
          </div>

          {/* Прокручиваемый контент */}
          <div className="container flex-1 overflow-y-auto flex flex-col lg:flex-row justify-between items-start leading-none">
            <div className='mt-[12px] lg:mt-0'>
              <a href={links?.catalog} className='block text-cardTitle text-[#001553] mb-[12px] uppercase'>Продукция</a>
              <div className='pl-[10px] text-ptgray text-base pb-[20px] border-b border-[#1414141A] mb-[18px]'>
                {catalog_menu.map((item, index) => (
                  <a key={index} href={item.url} className='block mb-[12px]'>
                    {item.pagetitle}
                  </a>
                ))}
              </div>
              {menu.map((item, index) => (
                <a key={index} href={item.url} className='block text-cardTitle text-ptblack mb-[18px] uppercase'>
                  {item.pagetitle}
                </a>
              ))}
            </div>
            <div className='lg:border-l-[1px] border-[#1414141A] lg:pl-[40px] flex-none mt-[62px] lg:mt-0 w-full lg:w-auto pb-[30px] lg:pb-0'>
              <div className='text-cardTitle text-[#001553] uppercase'>Контакты</div>
              <div className='text-ptgray text-small mt-[20px] max-w-[243px]'>
                {Parser(data?.slogan2 || '')}
              </div>
              <div className='mt-[30px] lg:mt-[40px] flex items-center gap-[10px]'>
                <div onClick={() => this.openCallForm()} className='cursor-pointer bg-[#BC0005] duration-300 ease-in-out hover:bg-[#930105] px-[32px] h-[42px] flex-none flex items-center justify-center rounded-[14px] gap-[12px] text-white'>
                  <PhoneIcon width={15} height={15} stroke="currentColor" />
                  <div className='text-base'>Связаться</div>
                </div>
                {/* Измененная кнопка "Схема проезда" - открывает Lightbox вместо ссылки */}
                <div 
                  onClick={() => this.openSchemaLightbox()} 
                  className='cursor-pointer bg-[#001553] px-[32px] h-[42px] flex-none flex items-center justify-center rounded-[14px] gap-[12px] text-white'
                >
                  <MapDirectionsIcon width={16} height={16} stroke="white" />
                  <div className='text-base'>Схема проезда</div>
                </div>
              </div>
              <div className='flex items-center gap-[9px] text-ptblack text-[16px] mt-[30px] lg:mt-[40px] uppercase'>
                <PhoneIcon width={15} height={15} stroke="#141414" />
                <div>Телефоны</div>
              </div>
              <div className='flex items-center gap-[20px] text-[12px] text-ptgray mt-[12px]'>
                {data?.phone.map( ( phone, k ) => (
                  <a href={`tel:${phone.replace(/[-()\s]/g, '')}`} key={k}>{phone}</a>
                ) )}
              </div>
              <div className='flex items-center gap-[9px] text-ptblack text-[16px] mt-[20px] uppercase'>
                <EmailIcon width={16} height={16} stroke="#141414" />
                <div>e-mail</div>
              </div>
              <div className='flex items-center gap-[20px] text-[12px] text-ptgray mt-[12px]'>
                {data?.email.map( ( email, k ) => (
                  <a href={`mailto:${email}`} key={k}>{email}</a>
                ) )}
              </div>
              <div className='flex items-center gap-[9px] text-ptblack text-[16px] mt-[20px] uppercase'>
                <LocationIcon width={16} height={16} stroke="#141414" />
                <div>Адрес</div>
              </div>
              <a href={data?.adreslink || ''} target='_blank' className='flex items-center gap-[20px] text-[12px] text-ptgray mt-[12px]'>
                <div>{Parser(data?.adres || '')}</div>
              </a>
              <a href={links?.pconf} className='text-small text-ptgray mt-[60px] block'>Политика конфиденциальности</a>
              <div className='text-small text-ptgray mt-[20px]'>© {new Date().getFullYear()} {data?.copy}</div>
            </div>
          </div>
        </div>

        {/* Lightbox для схемы проезда */}
        {lightboxOpen && (
          <div 
            className='fixed inset-0 z-[60] flex items-center justify-center bg-black bg-opacity-90'
            onClick={this.closeSchemaLightbox}
          >
            {/* Кнопка закрытия */}
            <button 
              className='absolute top-5 right-5 text-white text-4xl hover:text-gray-300 z-10 w-[50px] h-[50px] flex items-center justify-center rounded-full bg-black/50 hover:bg-black/70 transition-colors'
              onClick={this.closeSchemaLightbox}
            >
              ×
            </button>

            {/* Изображение схемы проезда */}
            <div 
              className='relative max-w-[90vw] max-h-[90vh] rounded-[15px] overflow-hidden'
              onClick={(e) => e.stopPropagation()}
            >
              <img 
                src={data?.schemagif} 
                alt='Схема проезда'
                className='max-w-full max-h-[90vh] object-contain'
              />
              
              {/* Подпись */}
              <div className='absolute bottom-5 left-1/2 -translate-x-1/2 text-white bg-black bg-opacity-70 px-4 py-2 rounded-full text-sm whitespace-nowrap'>
                Схема проезда
              </div>
            </div>
          </div>
        )}

        {/* Форма заказа звонка */}
        <OffcanvasForm
          show={showCallForm}
          hide={this.closeCallForm}
          formTitle="Связаться"
          formText="Оставьте свои контактные данные, и мы свяжемся с вами в ближайшее время."
          productName="" // Можно передать название товара, если нужно
          onSuccess={this.handleFormSuccess}
          onError={this.handleFormError}
        />
      </>
    );
  }
}

export default Offcanvas;